import { IAddressComponentViewModel, ILocationViewModel } from "Services/API/API";

export interface PlaceAddressFormat {
   country: IAddressComponentViewModel;
   city: IAddressComponentViewModel;
   state: IAddressComponentViewModel;
   route: IAddressComponentViewModel;
   street_number: IAddressComponentViewModel;
   zip: IAddressComponentViewModel;
}

const getAddressComponent = (location: ILocationViewModel, addressComponentType: string): IAddressComponentViewModel => {
   return location.addressComponents.filter(function (address_component) {
      return address_component.types.some(function (address_component_type) {
         return address_component_type == addressComponentType;
      });
   })[0]
}

export const parsePlaceToAddress = (location: ILocationViewModel): PlaceAddressFormat => {
   const route = getAddressComponent(location, "route");
   const street_number = getAddressComponent(location, "street_number");
   const city = getAddressComponent(location, "locality");
   const state = getAddressComponent(location, "administrative_area_level_1");
   const country = getAddressComponent(location, "country");
   const zip = getAddressComponent(location, "postal_code");

   return {
      country,
      city,
      state,
      route,
      street_number,
      zip
   }
}